// @flow
import React from 'react';
import { Grid } from 'semantic-ui-react';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { StyledLabel } from '@src/common-utils/styledComponents';
import MappedDataRenderer from '@streaming-projects/resource-definitions/auxilary-components/MappedDataRenderer';
import { useMetaDataContext } from '@streaming-projects/orgs/contexts/SPMetaDataContextProvider';
import { StyledH5 } from '@presentational/headings/StyledH5';
import {
  TABLEFLOW_RESOURCES_GRID_FIELDNAMES,
  TABLEFLOW_RESOURCES_GRID_HEADERS,
} from '@streaming-projects/orgs/enums';
import { useSPTableFlowContext } from '@streaming-projects/workloads/tableflow-workloads/contexts/SPTableFlowWorkloadContextProvider';
import { isAnythingEditedBesidesGivenFormBasedOnGivenConfig } from '@streaming-projects/utils';
import { useFormikContext } from 'formik';
import { TABLEFLOW_WORKLOAD_DETAILS_CONFIG } from '@streaming-projects/workloads/tableflow-workloads/config';

export const SPTableFlowWorkloadResourceDetailsContainer = () => {
  const spTableFlowWorkloadData = useSPTableFlowContext();
  const { providerRegionsMap, providerNameLabelMap, tableFlowStorageTypeMap } =
    useMetaDataContext();
  const { values, initialValues } = useFormikContext();

  const {
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.NAME]: name,
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.STORAGE_TYPE]: storageType,
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_NAME]: clusterResourceName,
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_REGION]: clusterResourceRegion,
    [TABLEFLOW_RESOURCES_GRID_FIELDNAMES.CLUSTER_RESOURCE_PROVIDER]: clusterResourceProvider,
  } = spTableFlowWorkloadData[TABLEFLOW_RESOURCES_GRID_FIELDNAMES.RESOURCE_DETAILS];

  const shouldFormBeDisabled = isAnythingEditedBesidesGivenFormBasedOnGivenConfig(
    initialValues,
    values,
    TABLEFLOW_WORKLOAD_DETAILS_CONFIG
  );

  return (
    <PaddedAndRaisedSegment disabled={shouldFormBeDisabled}>
      <Grid columns={3} divided={true}>
        <Grid.Row>
          <Grid.Column>
            <StyledH5 text={TABLEFLOW_RESOURCES_GRID_HEADERS.NAME} />
            <section>
              <StyledLabel>{name}</StyledLabel>
            </section>
          </Grid.Column>
          <Grid.Column>
            <StyledH5 text={TABLEFLOW_RESOURCES_GRID_HEADERS.STORAGE_TYPE} />
            <section>
              <StyledLabel>
                <MappedDataRenderer mapping={tableFlowStorageTypeMap} value={storageType} />
              </StyledLabel>
            </section>
          </Grid.Column>
          <Grid.Column>
            <StyledH5 text={TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_PROVIDER} />
            <section>
              <StyledLabel>
                <MappedDataRenderer
                  mapping={providerNameLabelMap}
                  value={clusterResourceProvider}
                />
              </StyledLabel>
            </section>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <StyledH5 text={TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_REGION} />
            <section>
              <StyledLabel>
                <MappedDataRenderer
                  mapping={providerRegionsMap[clusterResourceProvider].regions}
                  value={clusterResourceRegion}
                />
              </StyledLabel>
            </section>
          </Grid.Column>
          <Grid.Column>
            <StyledH5 text={TABLEFLOW_RESOURCES_GRID_HEADERS.CLUSTER_RESOURCE_NAME} />
            <section>
              <StyledLabel>{clusterResourceName}</StyledLabel>
            </section>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </PaddedAndRaisedSegment>
  );
};
